export const setStorage = (items: object) => {
  for (let key in items) {
    localStorage.setItem(key, items[key]);
  }
};
